import * as React from 'react';
import style from './IndexPageJsView.scss';
import { SectionContainer } from '../../../SectionContainer';
import { IndexPageMemberView, MEMBER_TYPES } from './IndexPageMemberView';
import { sortMembersBySortOrderFirst } from '../../../../../utils/applyMenuConfigChanges/addSortOrderProperty/sortBySortOrder';
import { IndexPageTagList } from '../IndexPageRESTView/IndexPageTagList';

export const IndexPageJsView = ({
  subCategories,
  properties,
  operations,
  clientEvents,
  prefix,
  mdGuides,
  tags = [],
}) => {
  return (
    <React.Fragment>
      <SectionContainer className={style.jsMemberViewContainer}>
        <IndexPageMemberView
          title="Guides"
          subtitle="Additional information about this section"
          members={mdGuides}
          prefix={prefix}
          memberDataHook="md-guides-entry"
        />
      </SectionContainer>
      <SectionContainer className={style.jsMemberViewContainer}>
        <IndexPageMemberView
          title="Properties"
          subtitle="Store values associated with an object"
          members={sortMembersBySortOrderFirst(properties)}
          prefix={prefix}
          memberDataHook="property-entry"
        />
      </SectionContainer>
      <SectionContainer className={style.jsMemberViewContainer}>
        <IndexPageMemberView
          memberDataHook="operation-entry"
          title="Functions"
          type={MEMBER_TYPES.function}
          subtitle="Perform actions on an object"
          members={sortMembersBySortOrderFirst(operations)}
          prefix={prefix}
        />
      </SectionContainer>
      <SectionContainer className={style.jsMemberViewContainer}>
        <IndexPageMemberView
          memberDataHook="client-event-entry"
          title="Client Events"
          type={MEMBER_TYPES.clientEvents}
          subtitle="Perform actions on an object"
          members={sortMembersBySortOrderFirst(clientEvents)}
          prefix={prefix}
        />
      </SectionContainer>
      <SectionContainer className={style.jsMemberViewContainer}>
        <IndexPageMemberView
          memberDataHook="sub-category-entry"
          title="Subcategories"
          type={MEMBER_TYPES.subCategory}
          members={subCategories}
          prefix={prefix}
        />
      </SectionContainer>
      {!!tags.length && <IndexPageTagList prefix={prefix} tags={tags} />}
    </React.Fragment>
  );
};
